import i18n from 'src/utils/translate';
import { showSignupModal } from 'src/modules/shared/modal/actions';
import { enrollUser } from 'src/modules/programs/actions';
import { useDispatch, useSelector } from 'src/store/store';
import Button from 'src/components/buttons/button';
type Props = {
  redirectPage?: () => void;
};
export default function EnrollButton({
  redirectPage = () => {}
}: Props) {
  const dispatch = useDispatch();
  const currentUser = useSelector(({
    context
  }) => context.currentUser);
  const isEnrolled = useSelector(({
    pages
  }) => pages.programs.isEnrolled);
  const onSignupOrLoginClick = () => {
    const onSignupSuccess = () => dispatch(enrollUser());
    dispatch(showSignupModal({
      onSignupSuccess,
      redirectPage
    }));
  };
  return currentUser ? !isEnrolled && <Button onClick={async () => {
    await dispatch(enrollUser());
    redirectPage();
  }}>
          {i18n.t('Enroll in program')}
        </Button> : <Button onClick={onSignupOrLoginClick}>
          {i18n.t('Join or login to enroll')}
        </Button>;
}